/**
 * platform.ts
 *
 * Detección de entorno: navegador web vs Capacitor nativo.
 * No importa @capacitor/core — usa globals inyectados por Capacitor.
 */

/** true si corre dentro de Capacitor (Android/iOS APK). */
export function isNativePlatform(): boolean {
  return !!(window as any).Capacitor?.isNativePlatform?.();
}

/** true si es un candidato SUNMI (nativo + Android). */
export function isSunmiCandidate(): boolean {
  return isNativePlatform() &&
    (window as any).Capacitor?.getPlatform?.() === 'android';
}

/** true si Web Bluetooth API está disponible (Chrome/Edge). */
export function isWebBluetoothAvailable(): boolean {
  return !!(navigator as any).bluetooth;
}
